var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDropzone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 26.75,
    stroke: "#FF7217",
    strokeWidth: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4915 17.2501C26.4915 16.5598 27.0512 16.0001 27.7415 16.0001C28.4319 16.0001 28.9915 16.5598 28.9915 17.2501V36.2854L34.982 30.2949C35.4701 29.8068 36.2616 29.8068 36.7497 30.2949C37.2379 30.7831 37.2379 31.5745 36.7497 32.0627L28.618 40.1944C28.1299 40.6826 27.3384 40.6826 26.8502 40.1944C26.789 40.1332 26.7354 40.0672 26.6896 39.9976C26.6216 39.9523 26.5571 39.8998 26.4972 39.8398L18.3654 31.7081C17.8773 31.22 17.8773 30.4285 18.3654 29.9403C18.8536 29.4522 19.6451 29.4522 20.1332 29.9403L26.4915 36.2986V17.2501Z",
    fill: "#FF7217"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropzone);
export default __webpack_public_path__ + "static/media/dropzone.cf4f5478ca0861a0aba842ea5b02835d.svg";
export { ForwardRef as ReactComponent };